import { canadaPainData } from "../../data/canadaTaxData";
import { HelpCircle, DollarSign, Monitor, Wallet, Mail, Clock } from "lucide-react";

const icons = [HelpCircle, DollarSign, Monitor, Wallet, Mail, Clock];

export const CanadaPainSection = () => (
  <section id="pain" className="py-24 px-6" style={{ background: "#F3F5F8" }}>
    <div className="max-w-[87.5rem] mx-auto">
      {/* Heading */}
      <div className="mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaPainData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaPainData.headline1}
          <br />
          <span className="text-[#C8283A]">{canadaPainData.headline2}</span>
        </h2>
        <p className="text-[#5A6A7A] text-base max-w-xl" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaPainData.sub}
        </p>
      </div>

      {/* 2x3 card grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {canadaPainData.cards.map((card, i) => {
          const Icon = icons[i];
          return (
            <div
              key={i}
              className="bg-white rounded-xl p-6 relative overflow-hidden border border-[#E8ECF0] hover:shadow-md hover:border-[#C8283A]/20 transition-all duration-300"
            >
              {/* Red top border accent */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#C8283A] to-transparent" />
              <div className="w-10 h-10 rounded-lg bg-[#FDF1F2] border border-[#C8283A]/10 flex items-center justify-center mb-4">
                <Icon size={18} className="text-[#C8283A]" />
              </div>
              <h3 className="text-[#0B1829] font-bold text-sm mb-2 leading-snug" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {card.headline}
              </h3>
              <p className="text-[#5A6A7A] text-sm leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {card.body}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
